import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, CircularProgress, Paper, Stack, Divider } from '@mui/material';
import { Apple as AppleIcon, PhoneAndroid as AndroidIcon } from '@mui/icons-material';
import { doc, getDoc } from 'firebase/firestore';
import { db, auth } from '../../firebase';
import { signOut } from 'firebase/auth';

const AppDownload = () => {
  const [urls, setUrls]       = useState({ appStoreUrl: '', playStoreUrl: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDoc(doc(db, 'settings', 'config'))
      .then(snap => {
        if (snap.exists()) {
          const d = snap.data();
          setUrls({ appStoreUrl: d.appStoreUrl || '', playStoreUrl: d.playStoreUrl || '' });
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const handleLogout = () => signOut(auth);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: '#f4f6f8',
      px: 2
    }}>
      <Paper sx={{
        p: { xs: 3, sm: 5 },
        maxWidth: 460,
        width: '100%',
        borderRadius: 3,
        textAlign: 'center',
        boxShadow: '0 8px 32px rgba(0,0,0,0.10)'
      }}>

        {/* Logo / icono */}
        <Box sx={{
          width: 80, height: 80, borderRadius: 3,
          bgcolor: '#68C683', mx: 'auto', mb: 3,
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <Typography variant="h4" sx={{ color: '#fff', fontWeight: 800 }}>AB</Typography>
        </Box>

        <Typography variant="h5" fontWeight={800} gutterBottom>
          AMPA del Bosc
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Descarga la app para acceder a todos los servicios, eventos y notificaciones de la AMPA.
        </Typography>

        <Stack spacing={2}>
          {/* iOS */}
          <Button
            fullWidth
            variant="contained"
            size="large"
            href={urls.appStoreUrl || '#'}
            target="_blank"
            rel="noopener noreferrer"
            disabled={!urls.appStoreUrl}
            startIcon={<AppleIcon />}
            sx={{
              bgcolor: '#000', color: '#fff', py: 1.5, borderRadius: 2, fontWeight: 700, fontSize: '1rem',
              '&:hover': { bgcolor: '#222' },
              '&.Mui-disabled': { bgcolor: '#ccc', color: '#fff' }
            }}
          >
            Descargar en App Store
          </Button>

          {/* Android */}
          <Button
            fullWidth
            variant="contained"
            size="large"
            href={urls.playStoreUrl || '#'}
            target="_blank"
            rel="noopener noreferrer"
            disabled={!urls.playStoreUrl}
            startIcon={<AndroidIcon />}
            sx={{
              bgcolor: '#3ddc84', color: '#000', py: 1.5, borderRadius: 2, fontWeight: 700, fontSize: '1rem',
              '&:hover': { bgcolor: '#2ecc6e' },
              '&.Mui-disabled': { bgcolor: '#ccc', color: '#fff' }
            }}
          >
            Descargar en Google Play
          </Button>
        </Stack>

        {!urls.appStoreUrl && !urls.playStoreUrl && (
          <Typography variant="caption" color="text.disabled" sx={{ display: 'block', mt: 2 }}>
            Los enlaces aún no están configurados. Contacta con la administración.
          </Typography>
        )}

        <Divider sx={{ my: 3 }} />

        <Button
          variant="text"
          color="inherit"
          size="small"
          onClick={handleLogout}
          sx={{ color: 'text.disabled', fontSize: 12 }}
        >
          Cerrar sesión
        </Button>
      </Paper>
    </Box>
  );
};

export default AppDownload;
